import { ApiData } from 'states/types'
import NivosPost from 'types/nivos-post'

const Types = {
  SET: '@@nivos-post/SET',
  ADD: '@@nivos-post/ADD',
  UPDATE: '@@nivos-post/UPDATE',
  LOADING: '@@nivos-post/LOADING',
  DELETE: '@@nivos-post/DELETE'
}

export type Payload = ApiData<NivosPost>

export { Types }
